import SantanderLogo from '../assets/images/banks/banco-santander.png'
import ProvincialLogo from '../assets/images/banks/banco-provincial.webp'
import BancaribeLogo from '../assets/images/banks/bancaribe.jpeg'
import BancoExteriorLogo from '../assets/images/banks/banco-exterior.jpg'
import BancoCajaSocial from '../assets/images/banks/caja-social.png'
import ZinliLogo from '../assets/images/banks/zinli.jpg'
import MercantilLogo from '../assets/images/banks/mercantil.png'
import BancoDeGuayaquilLogo from '../assets/images/banks/bancodeguayaquil.png'
import BCILogo from '../assets/images/banks/bci.png'
import ScotiabankLogo from '../assets/images/banks/banco-scotiabank.png'
import BancoDeChileLogo from '../assets/images/banks/banco-chile.png'
import BNCLogo from '../assets/images/banks/bnc.png'
import BancoEstado from '../assets/images/banks/banco-estado.jpg'
import BancoFalabella from '../assets/images/banks/banco-falabella.svg'
import BinanceLogo from "../assets/images/svg/binance.png";
import ZelleLogo from "../assets/images/banks/zelle.png";
import NequiLogo from "../assets/images/banks/nequi.png";
import YapeLogo from "../assets/images/banks/yape.png";

import PaypalLogo from "../assets/images/svg/paypal.png";
import CashLogo from "../assets/images/banks/cash.png";
import LemonCashLogo from "../assets/images/banks/lemoncash.png";
import BCPLogo from "../assets/images/banks/bcp.png";

import BancoTenpoLogo from "../assets/images/banks/banco-tenpo.png";
import MercadoPagoLogo from "../assets/images/banks/mercado-pago.jpg";
import PlinLogo from "../assets/images/banks/plin.png";
import BBVALogo from "../assets/images/banks/bbva.png";
import BancolombiaLogo from "../assets/images/banks/bancolombia.png";
import BancoDeVenezuelaLogo from "../assets/images/banks/banco-de-venezuela.png";
import BancaAmiga from "../assets/images/banks/banca-amiga.png";
import BanescoLogo from "../assets/images/banks/banesco.png";
import BizumLogo from "../assets/images/banks/bizum.webp";
import BDTLogo from "../assets/images/banks/bdt.jpg";
import CaixaBankLogo from "../assets/images/banks/caixabank.png";
import PagoMovilLogo from "../assets/images/banks/pagomovil.png";
import PichinchaLogo from "../assets/images/banks/pichincha.jpeg";
import NickelLogo from "../assets/images/banks/nickel.png";
import BancoGeneralPanama from "../assets/images/banks/bancogeneralpanama.jpg";
import CuentaNaranjaLogo from "../assets/images/banks/cuentanaranja.png";
import CashAppLogo from "../assets/images/banks/cashapp.png";
import BanreservasLogo from "../assets/images/banks/banreservas.jpeg";
import WiseLogo from "../assets/images/banks/wise.png";
import BicentenarioLogo from "../assets/images/banks/bicentenario.png";
import BancoDelTesoroLogo from "../assets/images/banks/bancodeltesoro.jpg";
import MajorityLogo from "../assets/images/banks/majority.png";


import { IBank } from "../store/interfaces/IBankAccount";

 

export const banks: IBank[] = [
    {
      id: 'santander',
      country: 'CL',
      name: 'Santander',
      icon: <img src={SantanderLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'wise',
      country: 'CL',
      name: 'Wise',
      icon: <img src={WiseLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'majority',
      country: 'CL',
      name: 'Majority',
      icon: <img src={MajorityLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bicentenario',
      country: 'CL',
      name: 'Bicentenario',
      icon: <img src={BicentenarioLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancodeltesoro',
      country: 'CL',
      name: 'Banco Del Tesoro',
      icon: <img src={BancoDelTesoroLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'banreservas',
      country: 'RD',
      name: 'Banreservas',
      icon: <img src={BanreservasLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'cuentanaranja',
      country: 'CL',
      name: 'Cuenta Naranja',
      icon: <img src={CuentaNaranjaLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'cashapp',
      country: 'CL',
      name: 'Cash App',
      icon: <img src={CashAppLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'caixabank',
      country: 'CL',
      name: 'Caixabank',
      icon: <img src={CaixaBankLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancogeneralpanama',
      name: 'Banco General de Panama',
      country: 'CL',
      icon: <img src={BancoGeneralPanama} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'nickel',
      country: 'CL',
      name: 'Nickel',
      icon: <img src={NickelLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'pichincha',
      country: 'CL',
      name: 'Pichincha',
      icon: <img src={PichinchaLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'pagomovil',
      country: 'CL',
      name: 'Pago Movil',
      icon: <img src={PagoMovilLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'lemoncash',
      country: 'CL',
      name: 'Lemon Cash',
      icon: <img src={LemonCashLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bbva',
      country: 'CL',
      name: 'BBVA',
      icon: <img src={BBVALogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'provincial',
      country: 'CL',
      name: 'Provincial',
      icon: <img src={ProvincialLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bcp',
      country: 'CL',
      name: 'BCP',
      icon: <img src={BCPLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bnc',
      country: 'VE',
      name: 'BNC',
      icon: <img src={BNCLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancaribe',
      country: 'CL',
      name: 'Ban Caribe',
      icon: <img src={BancaribeLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'banco-exterior',
      country: 'CL',
      name: 'Banco Exterior',
      icon: <img src={BancoExteriorLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'caja-social',
      country: 'CL',
      name: 'Banco Caja Social',
      icon: <img src={BancoCajaSocial} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'zinli',
      country: 'CL',
      name: 'Zinli',
      icon: <img src={ZinliLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bdt',
      country: 'VE',
      name: 'Banco de Trabajadores',
      icon: <img src={BDTLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bizum',
      country: 'CL',
      name: 'Bizum',
      icon: <img src={BizumLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'mercantil',
      country: 'CL',
      name: 'Mercantil',
      icon: <img src={MercantilLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancodeguayaquil',
      country: 'CL',
      name: 'Banco de Guayaquil',
      icon: <img src={BancoDeGuayaquilLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bci',
      country: 'CL',
      name: 'BCI/MACH',
      icon: <img src={BCILogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancofalabella',
      country: 'CL',
      name: 'Falabella',
      icon: <img src={BancoFalabella} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancochile',
      country: 'CL',
      name: 'Banco de Chile',
      icon: <img src={BancoDeChileLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancoestado',
      country: 'CL',
      name: 'Banco Estado',
      icon: <img src={BancoEstado} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'scotiabank',
      country: 'CL',
      name: 'Scotiabank',
      icon: <img src={ScotiabankLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'tenpo',
      country: 'CL',
      name: 'Banco Prepago Tenpo',
      icon: <img src={BancoTenpoLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'mercadopago',
      country: 'CL',
      name: 'Mercado Pago',
      icon: <img src={MercadoPagoLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'paypal',
      country: 'CL',
      name: 'Paypal',
      icon: <img src={PaypalLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'cash',
      country: 'CL',
      name: 'Efectivo',
      icon: <img src={CashLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'binance',
      country: 'CL',
      name: 'Binance',
      icon: <img src={BinanceLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'plin',
      country: 'CL',
      name: 'Plin',
      icon: <img src={PlinLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancolombia',
      country: 'CL',
      name: 'Bancolombia',
      icon: <img src={BancolombiaLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancodevenezuela',
      country: 'CL',
      name: 'Banco de Venezuela',
      icon: <img src={BancoDeVenezuelaLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'banesco',
      country: 'CL',
      name: 'Banco de Venezuela',
      icon: <img src={BanescoLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'zelle',
      country: 'CL',
      name: 'Zelle',
      icon: <img src={ZelleLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'nequi',
      country: 'CL',
      name: 'Nequi',
      icon: <img src={NequiLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'yape',
      country: 'CL',
      name: 'Yape',
      icon: <img src={YapeLogo} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
    {
      id: 'bancaamiga',
      country: 'VE',
      name: 'Banca Amiga',
      icon: <img src={BancaAmiga} style={{ borderRadius: 2 }} height={40} width={40} alt='Logo'></img>
    },
  ];


interface GetIconFromBankIdProps {
  bankId: string;
  width: number;
  height: number;
}

export const getIconFromBankId = ({ bankId, width = 40, height = 40 }: GetIconFromBankIdProps) => {
  const bank = banks.find(bank => bank.id === bankId);
  if (!bank) return null;

  return (
    <img
      src={(bank.icon as React.ReactElement).props.src}
      style={{ borderRadius: 2 }}
      width={width}
      height={height}
      alt='Logo'
    />
  );
};